{
  "category": {
    "addCategory": "إضافة فئة",
    "confirms": {
      "deleteTitle": "حذف {name}؟",
      "deleteTextImmediate": "لا تحتوي هذه الفئة على أي إجراءات ويمكن حذفها فورًا. لا يمكن التراجع عن هذا الإجراء.",
      "chooseReassignMode": "لا تزال هذه الفئة تحتوي على إجراءات. اختر كيفية إعادة تعيينها قبل الحذف.",
      "deleteTextAllAtOnce": "اختر فئة لنقل جميع الإجراءات إليها. لا يمكن التراجع عن هذا الإجراء.",
      "deleteTextOneByOne": "راجع الإجراءات أدناه، ثم اختر فئة لنقلها جميعًا إليها.",
      "affectedProcedures": "الإجراءات التي سيتم نقلها",
      "stillHasProcedures": "لا تزال هذه الفئة مرتبطة بإجراءات. يرجى اختيار فئة هدف."
    },
    "createdNewCategory": "إنشاء فئة جديدة",
    "deletedCategory": "تم حذف الفئة",
    "description": "وصف",
    "editCategory": "تعديل الفئة",
    "frequency": "التكرار",
    "name": "اسم",
    "reassignAllAtOnce": "إعادة تعيين جميع الإجراءات دفعة واحدة",
    "reassignOneByOne": "إعادة التعيين واحدًا تلو الآخر",
    "reassignTo": "إعادة التعيين إلى",
    "searchCategories": "البحث عن الفئات",
    "updatedCategory": "تم تحديث الفئة"
  },
  "datatable": {
    "rowsPerPage": "الصفوف في الصفحة"
  },
  "department": {
    "addDepartment": "إضافة قسم",
    "confirms": {
      "deleteText": "سيتم إعادة تعيين جميع المستخدمين والإجراءات وعناصر التعلم والدراسات والأجهزة في هذا القسم إلى القسم الذي تحدده أدناه. لا يمكن التراجع عن هذا.",
      "deleteTitle": "حذف {name}؟",
      "restoreText": "سيؤدي هذا إلى إظهار القسم مرة أخرى واستعادة الوصول لموظفيه.",
      "restoreTitle": "استعادة {name}؟"
    },
    "createdNewDepartment": "تم إنشاء القسم بنجاح",
    "createNewDepartment": "إضافة قسم",
    "deletedDepartment": "تم حذف القسم",
    "deleteDepartment": "حذف القسم",
    "departmentAdmin": "مسؤول القسم",
    "departmentName": "اسم القسم",
    "edit": "تحرير",
    "institution": "اسم المؤسسة",
    "institutionName": "اسم المؤسسة",
    "noReassignmentTarget": "هذا هو القسم الوحيد في المؤسسة. أنشئ قسمًا آخر قبل حذف هذا القسم.",
    "reassignTo": "إعادة التعيين إلى قسم",
    "restore": "استعادة",
    "restoredDepartment": "تم استعادة القسم",
    "searchDepartments": "قسم البحث (الأقسام)",
    "showArchived": "إظهار الأقسام المؤرشفة",
    "thisFieldIsRequired": "هذا الحقل مطلوب",
    "updatedDepartment": "تم تحديث القسم بنجاح"
  },
  "form": {
    "canNotEndBeforeParentStarts": "لا يمكن أن تنتهي عندما لم يبدأ الأصل",
    "canNotEndBeforeStart": "لا يمكن أن تنتهي قبل البدء",
    "canNotEndWhenParentEnded": "لا يمكن أن تنتهي عند انتهاء الأصل",
    "canNotStartAfterEnd": "لا يمكن أن تبدأ بعد نهاية",
    "canNotStartBeforeParentStarts": "لا يمكن البدء قبل بدء تشغيل الأصل",
    "canNotStartWhenParentEnded": "لا يمكن أن تبدأ عند انتهاء الأصل",
    "thisFieldIsRequired": "هذا الحقل مطلوب"
  },
  "general": {
    "accessDenied": "تم رفض الوصول",
    "add": "اضافه",
    "back": "عوده",
    "cancel": "إلغاء الأمر",
    "close": "قم بإغلاق",
    "dateAdded": "تاريخ الإضافة",
    "dateUpdated": "تاريخ التحديث",
    "delete": "حذف",
    "edit": "تحرير",
    "endDate": "تاريخ الانتهاء",
    "loading": "تحميل...",
    "name": "اسم",
    "no": "لا",
    "noData": "لا توجد بيانات",
    "ok": "موافق",
    "remove": "ازاله",
    "save": "حفظ",
    "selectAll": "تحديد الكل",
    "startDate": "تاريخ البدء",
    "yes": "نعم",
    "selectGender": "اختر الجنس",
    "gender": {
      "male": "ذكر",
      "female": "أنثى"
    },
    "action": "الإجراء",
    "created": "تم الإنشاء",
    "updated": "تم التحديث",
    "deleted": "تم الحذف",
    "enabled": "مفعّل",
    "noHistory": "لا يوجد سجل"
  },
  "institution": {
    "accessRevoked": "تمت إزالة مؤسستك. تم تسجيل خروجك.",
    "confirms": {
      "deleteText": "سيؤدي هذا إلى إخفاء المؤسسة وأقسامها من لوحة الإدارة وإلغاء الوصول فورًا لجميع الموظفين. يمكن التراجع عن هذا عن طريق استعادة المؤسسة.",
      "deleteTitle": "حذف {name}؟",
      "restoreText": "سيؤدي هذا إلى إظهار المؤسسة وأقسامها مرة أخرى واستعادة الوصول لموظفيها.",
      "restoreTitle": "استعادة {name}؟"
    },
    "contact": "الاتصال",
    "createdNewInstitution": "إنشاء مؤسسة جديدة",
    "createNewInstitution": "إضافة مؤسسة",
    "deletedInstitution": "تم حذف المؤسسة",
    "deleteInstitution": "حذف المؤسسة",
    "edit": "تحرير",
    "institutionCity": "المدينه",
    "institutionCountry": "البلد",
    "institutionCounty": "مقاطعه",
    "institutionHouse": "المنزل",
    "institutionLanguage": "اللغه",
    "institutionStreet": "الشارع",
    "institutionTimezone": "Timezone",
    "name": "اسم",
    "region": "المنطقه",
    "restore": "استعادة",
    "restoredInstitution": "تم استعادة المؤسسة",
    "searchInstitutions": "البحث في المؤسسات (المؤسسات)",
    "showArchived": "إظهار المؤسسات المؤرشفة",
    "street": "الشارع",
    "switch": "التبديل",
    "switchedTo": "تحولت المؤسسات إلى",
    "unableToSwitch": "غير قادر على التبديل",
    "updatedInstitution": "مؤسسة محدثة"
  },
  "menu": {
    "categories": "الفئات",
    "departments": "الادارات",
    "home": "المنزل",
    "institutions": "المؤسسات",
    "procedure": "إجراء",
    "procedures": "الاجراءات",
    "manageProcedures": "إدارة الإجراءات",
    "manageCategories": "إدارة الفئات",
    "reinviteusers": "إعادة دعوة المستخدمين",
    "scheduling": "جدوله",
    "study": "درس",
    "survey": "الدراسه الاستقصائيه",
    "userGuide": "دليل المستخدم",
    "users": "المستخدمين"
  },
  "device": {
    "udi": "UDI"
  },
  "procedure": {
    "addNewCategory": "إضافة فئة جديدة",
    "allSteps": "جميع الخطوات",
    "authors": "كاتب",
    "category": "الفئه",
    "createNewStep": "إضافة خطوة",
    "defineFeedback": "تعريف الملاحظات",
    "department": "اداره",
    "description": "وصف",
    "disableProcedure": "تعطيل الإجراء",
    "addProceduresInformation": "إضافة معلومات الإجراء",
    "editProceduresInformation": "تحرير معلومات الإجراء",
    "duplicateStartEndStepWarning": "يُسمح بخطوة بداية واحدة وخطوة نهاية واحدة فقط",
    "import": "استيراد",
    "information": "المعلومات",
    "institution": "المؤسسه",
    "language": "اللغه",
    "languagesAvailable": "اللغات المتاحة",
    "media": "وسائط",
    "name": "اسم",
    "owner": "مالك",
    "procedureCategory": "فئة الإجراء",
    "procedureLanguage": "لغة الإجراء",
    "procedureName": "اسم الإجراء",
    "procedureNotFound": "لم يتم العثور على الإجراء",
    "public": "العامه",
    "publicPrivate": "القطاع العام/الخاص",
    "revisionHistory": "تاريخ المراجعة",
    "searchSteps": "خطوة البحث (خطوات)",
    "seeFeedback": "الاطلاع على الملاحظات",
    "statistics": "الاحصاءات",
    "step": "خطوه",
    "stepNr": "Nr",
    "thisFieldIsRequired": "هذه الخانة مطلوبه",
    "unableToLoad": "غير قادر على تحميل الإجراء",
    "viewAs": "عرض ك",
    "checklist": "قائمة التحقق",
    "status": "الحالة",
    "revisionDate": "التاريخ",
    "revisionUser": "المستخدم",
    "revisionChanges": "التغييرات",
    "revisionStepAdded": "أُضيفت",
    "revisionStepRemoved": "أُزيلت",
    "revisionStepUpdated": "حُدّثت",
    "revisionStepReordered": "أُعيد ترتيبها"
  },
  "procedures": {
    "addProcedure": "إضافة إجراء",
    "category": "الفئه",
    "deleteProcedure": "حذف الإجراء",
    "department": "اداره",
    "filter": "تصفيه",
    "importProcedures": "إجراءات الاستيراد",
    "private": "الخاصه",
    "procedures": "الاجراءات",
    "public": "العامه",
    "publicPrivate": "القطاع العام/الخاص",
    "searchProcedures": "إجراءات البحث",
    "sort": "نوع"
  },
  "question": {
    "added": "إنشاء سؤال جديد",
    "answers": "اجابات",
    "cognitionName": "اسم الإدراك",
    "cognitionType": "نوع الإدراك",
    "details": "تفاصيل",
    "meaning": "معنى",
    "name": "اسم",
    "options": "خيارات",
    "position": "موقف",
    "question": "السؤال",
    "questionType": "نوع السؤال",
    "set": "تعيين",
    "type": "نوع",
    "types": {
      "CHOICE": "اختيار",
      "COGNITION": "الادراك",
      "SCALE": "نطاق"
    },
    "value": "قيمه",
    "editQuestion": "تحرير السؤال",
    "deleteQuestion": "حذف السؤال"
  },
  "step": {
    "addDescription": "إضافة وصف",
    "addParentStep": "إضافة الخطوة الأصل",
    "chooseParentSep": "اختر الخطوة الأصل",
    "chooseStepOption": "اختيار خيار الخطوة",
    "chooseTransitionType": "اختيار نوع الانتقال",
    "chooseType": "اختر النوع",
    "description": "وصف",
    "dropFilesOrClickToUpload": "إسقاط الملفات هنا أو انقر لتحميل",
    "editStep": "تحرير الخطوة",
    "insertMaxValue": "إدراج قيمة MAX",
    "insertMinValue": "إدراج قيمة MIN",
    "insertOption": "إدراج خيار",
    "option": "الخيار",
    "owner": "مالك",
    "parentStep": "الخطوة الأصل",
    "previousStep": "الخطوة السابقة",
    "saveMedia": "حفظ",
    "stepMedia": "وسائط الخطوة",
    "transitionToNextStep": "الانتقال إلى الخطوة التالية",
    "transitionType": "نوع الانتقال",
    "type": "نوع",
    "value": "قيمه",
    "viewInProcedure": "عرض في الإجراء",
    "error": {
      "WONT_REACH_END": "لا يوجد مسار إلى النهاية",
      "EXIT_NOT_IN_USE": "مخرج غير مستخدم",
      "NO_PARENT_SET": "لا توجد خطوة سابقة",
      "PARENT_NOT_EXITS": "الخطوة الأصل المحددة غير موجودة",
      "DUPLICATE_START": "لا يمكن أن تحتوي الإجراءات على أكثر من خطوة بداية",
      "DUPLICATE_END": "لا يمكن أن تحتوي الإجراءات على أكثر من خطوة نهاية",
      "NO_START": "لا يحتوي الإجراء على خطوة بداية",
      "NO_END": "لا يحتوي الإجراء على خطوة نهاية",
      "MULTIPLE_CHILDREN_FOR_EXIT": "يتم استخدام المخرج من قبل أكثر من خطوة واحدة"
    }
  },
  "study": {
    "addStudy": "إضافة دراسة",
    "author": "كاتب",
    "createdNewStudy": "إنشاء دراسة جديدة",
    "deletedStudy": "الدراسة المحذوفة",
    "deleteStudy": "حذف الدراسة",
    "department": "اداره",
    "description": "وصف",
    "duration": "مده",
    "endDate": "تاريخ الانتهاء",
    "name": "اسم",
    "owner": "مالك",
    "permission": {
      "department": "اداره",
      "institution": "المؤسسه"
    },
    "searchStudy": "البحث عن الدراسات",
    "startDate": "تاريخ البدء",
    "status": "حاله",
    "studyName": "اسم الدراسة",
    "updatedStudy": "دراسة محدثة",
    "visibility": "الرؤيه"
  },
  "survey": {
    "addAssessmentPeriod": "إنشاء فترة فرعية جديدة",
    "added": "إنشاء استطلاع جديد",
    "addNew": "أضافه جديد",
    "addPeriod": "إضافة فترة جديدة",
    "addSurveyPeriod": "إنشاء فترة استطلاع جديدة",
    "allAssessmentPeriods": "جميع فترات التقييم",
    "ASSESSMENT_PERIOD": "فترة التقييم",
    "author": "كاتب",
    "completePreviousPeriods": "هل يتعين على المشارك في الدراسة إكمال فترة (فترات) سابقة لتمكين هذه الفترة؟",
    "createNewPeriod": "إنشاء فترة جديدة",
    "createNewQuestion": "إضافة سؤال",
    "createNewSurvey": "إنشاء استطلاع جديد",
    "duration": "مده",
    "endDate": "تاريخ الانتهاء",
    "key": "مفتاح",
    "name": "اسم",
    "NONE": "اي",
    "period": "الفتره",
    "periodName": "اسم",
    "position": "موقف",
    "question": "السؤال",
    "questionList": "الاسئله",
    "startDate": "تاريخ البدء",
    "SURVEY_PERIOD": "فترة المسح",
    "type": "نوع"
  },
  "user": {
    "accountSettings": "إعدادات الحساب",
    "chooseUserRole": "اختيار دور المستخدم",
    "contact": "الاتصال",
    "contactInformation": "معلومات الاتصال",
    "dateOfBirth": "تاريخ الميلاد",
    "department": "اداره",
    "emails": "البريد الإلكتروني للمستخدم (ق)",
    "emailsDescription": "إدراج 1 أو أكثر من رسائل البريد الإلكتروني مفصولة بفواصل منقوطة. سيتم إرسال الدعوات للتسجيل بدور المستخدم المختار إلى المستخدمين عبر البريد الإلكتروني.",
    "filter": "تصفيه",
    "gender": "الجنسين",
    "institution": "المؤسسه",
    "institutionalAdmin": "مسؤول مؤسسي",
    "institutionAndDepartment": "المؤسسة والإدارة",
    "invite": "دعوه",
    "grantRole": "منح الدور",
    "revokeRole": "إلغاء الدور",
    "confirms": {
      "revokeRoleTitle": "إلغاء الدور",
      "revokeRoleText": "هل أنت متأكد أنك تريد إلغاء دور هذا المستخدم؟",
      "revokeRoleSuccess": "تم إلغاء الدور",
      "revokeRoleFailed": "فشل إلغاء الدور",
      "revokeRoleNoRole": "لم يتم العثور على تعيين دور لهذا المستخدم"
    },
    "inviteUsers": "دعوة المستخدمين",
    "logOut": "تسجيل الخروج",
    "noUsersSelected": "لم يتم تحديد مستخدمين",
    "nurse": "ممرض",
    "password": "كلمه المرور",
    "patient": "المريض",
    "reInviteUsers": "إعادة دعوة المستخدمين",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "resetRequestSentTo": "البريد الإلكتروني لراحة كلمة المرور المرسل إلى",
    "searchUsers": "بحث المستخدمين (المستخدمين)",
    "sendResetPasswordEmailTo": "إرسال بريد إلكتروني لإعادة تعيين كلمة المرور إلى",
    "sort": "نوع",
    "subscription": "الاشتراك",
    "thisFieldIsRequired": "هذا الحقل مطلوب",
    "user": "المستخدم",
    "userDetailsUpdated": "تم تحديث تفاصيل المستخدم",
    "userInformation": "معلومات المستخدم",
    "userRole": "دور المستخدم"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  },
  "patients": {
    "standingAssignment": "التخصيص الدائم",
    "noStandingAssignment": "لا يوجد تخصيص دائم",
    "unknownNurse": "الممرض/ة المخصص/ة (الاسم غير متوفر)",
    "standingAssignmentHelperText": "يمكن فقط تخصيص المستخدمين الذين لديهم دور \"ممرض منزلي\" (Home Nurse) كتخصيص دائم.",
    "changeStandingAssignment": "تغيير التخصيص",
    "clearStandingAssignment": "إزالة التخصيص",
    "confirmClearStandingAssignmentText": "هل أنت متأكد من أنك تريد إزالة التخصيص الدائم لهذا المريض؟",
    "standingAssignmentLabel": "{name} (دائم)",
    "onShiftLabel": "{name} (في الدوام)",
    "currentlyOnShiftWith": "في الدوام حاليًا مع",
    "notCurrentlyOnShift": "غير في الدوام حاليًا",
    "visitName": "الاسم",
    "visitDate": "التاريخ",
    "performedBy": "تم بواسطة",
    "status": "الحالة",
    "location": "الموقع / غرفة الجناح (اختياري)",
    "enterLocation": "أدخل الموقع أو رقم الغرفة",
    "admissionDate": "تاريخ الدخول (اختياري)",
    "dischargeDate": "تاريخ الخروج (اختياري)",
    "acuity": "درجة الخطورة (اختياري)",
    "unsupportedFieldsNotice": "الحساسية والأدوية والطول والوزن ونوع المريض ورمز/اسم الحالة غير مدعومة في هذا الاستيراد — يرجى إضافتها يدويًا بعد الاستيراد.",
    "import": {
      "importSucceeded": "تم استيراد {created} مريض(مرضى)، وتخطي {duplicates} من التكرارات.",
      "departmentsLoadFailed": "فشل تحميل الأقسام. يرجى المحاولة مرة أخرى."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "خطأ غير معروف"
  },
  "titles": {
    "categories": "الفئات",
    "visitreport": "تقرير الزيارة"
  },
  "toasts": {
    "patientAdded": "تمت إضافة المريض بنجاح",
    "patientUpdated": "تم تحديث المريض بنجاح",
    "procedureAdded": "تمت إضافة الإجراء بنجاح",
    "procedureUpdated": "تم تحديث الإجراء بنجاح",
    "procedureDeleted": "تم حذف الإجراء بنجاح",
    "visitAdded": "تمت إضافة الزيارة بنجاح",
    "visitUpdated": "تم تحديث الزيارة بنجاح",
    "visitDeleted": "تم حذف الزيارة بنجاح"
  },
  "studyResults": {
    "user": "المستخدم",
    "department": "القسم",
    "study": "الدراسة",
    "date": "التاريخ",
    "survey": "الاستبيان",
    "results": "النتائج",
    "studyResults": "نتائج الدراسة",
    "surveyResults": "نتائج الاستبيان",
    "list": "قائمة",
    "graph": "رسم بياني",
    "surveyStartDate": "بداية الاستبيان",
    "surveyEndDate": "نهاية الاستبيان",
    "userResults": "نتائج المستخدم",
    "question": "السؤال",
    "questionType": "نوع السؤال",
    "answer": "الإجابة",
    "position": "الموضع",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "الموافقة",
    "viewConsent": "عرض الموافقة",
    "homeVisit": "زيارة منزلية",
    "recomendationForTreatment": "توصيات للعلاج والرعاية والعمل والإشراف الخارجي",
    "anamnesis": "التاريخ المرضي",
    "answerType": "نوع الإجابة",
    "contactPhone": "هاتف التواصل",
    "contactEmail": "البريد الإلكتروني للتواصل",
    "visitMadeBy": "الزيارة قام بها",
    "homeVisitTime": "وقت الزيارة المنزلية",
    "visitForm": "نموذج الزيارة",
    "viewHistory": "عرض السجل",
    "patientsPrimaryHealthConcern": "المشكلة الصحية الأساسية للمريض",
    "conditionAssesmentInformation": "معلومات تقييم الحالة",
    "bloodPressure": "ضغط الدم",
    "measurement": "القياس",
    "BMI": "مؤشر كتلة الجسم",
    "diagnosis": "التشخيص",
    "appliedMedicalTreatments": "العلاج الدوائي المطبق",
    "appliedTreatment": "العلاج المطبق",
    "descriptionOfTestsConsultationPlans": "وصف الفحوصات/خطط الاستشارة",
    "instrumentalTests": "الفحوصات الآلية",
    "laboratoryTests": "الفحوصات المخبرية",
    "appliedMedicalTreatment": "العلاج الطبي المطبق",
    "specialist": "أخصائي",
    "status": "الحالة",
    "complaintData": "بيانات الشكوى",
    "pulse": "النبض",
    "viewFullVisitForm": "عرض نموذج الزيارة الكامل",
    "height": "الطول",
    "weight": "الوزن"
  }
}
